import { Injectable } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { MatSpinner } from '@angular/material/progress-spinner';


@Injectable()
export class UiSpinnerService {
  private spinnerTopRef: OverlayRef = this.cdkSpinnerCreate();
  isActive = false;

  constructor(private overlay: Overlay) {
  }


  private cdkSpinnerCreate() {
    return this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'sk-backdrop',
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically()
    });
  }


  showSpinner() {
    if (!this.isActive) {
      console.log('START SPINNER');
      this.spinnerTopRef.attach(new ComponentPortal(MatSpinner));
      this.isActive = true;
    }
  }

  stopSpinner() {
    if (this.isActive) {
      console.log('STOP SPINNER');
      this.spinnerTopRef.detach();
      this.isActive = false;

    }
  }


}
